import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	currentUserRole: {
		id: 'issue-field-role-picker.edit.current-user-role',
		defaultMessage: 'You',
		description: 'text shown to user on Role Dropdown to show the role,user belongs to',
	},
	placeholder: {
		id: 'issue-field-role-picker.edit.placeholder',
		defaultMessage: 'Select Roles',
		description: 'Placeholder text shown in the role dropdown',
	},
});
